// extracted by mini-css-extract-plugin
export default {"project-icon":"dLG4lrVGJJ0obmGPEBwx","text":"mkUoJYuqhV3WEMCfpiTt"};